import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import ProductLanding from "@/pages/ProductLanding";
import Corporate from "@/pages/Corporate";
import Malls from "@/pages/Malls";
import Education from "@/pages/Education";
import Expressways from "@/pages/Expressways";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ParentDashboard from "@/pages/ParentDashboard";
import ParentPreorder from "@/pages/ParentPreorder";
import ParentMyOrders from "@/pages/ParentMyOrders";
import ParentOrders from "@/pages/ParentOrders";
import InstaShop from "@/pages/InstaShop";
import ParentReports from "@/pages/ParentReports";
import ParentSOA from "@/pages/ParentSOA";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminMenu from "@/pages/AdminMenu";
import AdminMealPlans from "@/pages/AdminMealPlans";
import AdminMealPlansLegacy from "@/pages/AdminMealPlansLegacy";
import AdminUsers from "@/pages/AdminUsers";
import MasterStudentList from "@/pages/MasterStudentList";
import AdminOrders from "@/pages/AdminOrders";
import AdminReports from "@/pages/AdminReports";
import AdminInventory from "@/pages/AdminInventory";
import AdminExpenses from "@/pages/AdminExpenses";
import AdminStaff from "@/pages/AdminStaff";
import AdminFestivals from "@/pages/AdminFestivals";
import AdminSpecials from "@/pages/AdminSpecials";
import AdminWeeklyMenu from "@/pages/AdminWeeklyMenu";
import AdminVendors from "@/pages/AdminVendors";
import AdminFoodCourts from "@/pages/AdminFoodCourts";
import AdminGSTReport from "@/pages/AdminGSTReport";
import AdminEdkonnect from "@/pages/AdminEdkonnect";
import AdminQRCodes from "@/pages/AdminQRCodes";
import AdminConfiguration from "@/pages/AdminConfiguration";
import AdminItemSales from "@/pages/AdminItemSales";
import AdminConsumptionLog from "@/pages/AdminConsumptionLog";
import POS from "@/pages/POS";
import QR from "@/pages/QR";
import KDS from "@/pages/KDS";
import Kiosk from "@/pages/Kiosk";
import VendorPortal from "@/pages/VendorPortal";
import SuperAdmin from "@/pages/SuperAdmin";
import Profile from "@/pages/Profile";
import RfidTerminal from "@/pages/RfidTerminal";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<ProductLanding />} />
          <Route path="/platform" element={<Navigate to="/" replace />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/malls" element={<Malls />} />
          <Route path="/education" element={<Education />} />
          <Route path="/schools" element={<Landing />} />
          <Route path="/expressways" element={<Expressways />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/qr" element={<QR />} />
          <Route path="/kiosk" element={<Kiosk />} />

          <Route path="/parent" element={<ProtectedRoute roles={["parent","student","staff"]}><ParentDashboard /></ProtectedRoute>} />
          <Route path="/parent/preorder" element={<Navigate to="/parent/my-orders" replace />} />
          <Route path="/parent/instashop" element={<ProtectedRoute roles={["parent","student","staff"]}><InstaShop /></ProtectedRoute>} />
          <Route path="/parent/my-orders" element={<ProtectedRoute roles={["parent","staff"]}><ParentOrders /></ProtectedRoute>} />
          <Route path="/parent/reports" element={<ProtectedRoute roles={["parent","student","staff"]}><ParentReports /></ProtectedRoute>} />
          <Route path="/parent/soa" element={<Navigate to="/parent/my-orders" replace />} />

          <Route path="/superadmin" element={<ProtectedRoute roles={["super_admin"]}><SuperAdmin /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/menu" element={<ProtectedRoute roles={["admin"]}><AdminMenu /></ProtectedRoute>} />
          <Route path="/admin/meal-plans" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminMealPlans /></ProtectedRoute>} />
          <Route path="/admin/meal-plans-legacy" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminMealPlansLegacy /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/students" element={<ProtectedRoute roles={["admin","super_admin"]}><MasterStudentList /></ProtectedRoute>} />
          <Route path="/admin/orders" element={<ProtectedRoute roles={["admin"]}><AdminOrders /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute roles={["super_admin"]}><AdminReports /></ProtectedRoute>} />
          <Route path="/admin/inventory" element={<ProtectedRoute roles={["admin"]}><AdminInventory /></ProtectedRoute>} />
          <Route path="/admin/expenses" element={<ProtectedRoute roles={["admin"]}><AdminExpenses /></ProtectedRoute>} />
          <Route path="/admin/staff" element={<ProtectedRoute roles={["admin"]}><AdminStaff /></ProtectedRoute>} />
          <Route path="/admin/festivals" element={<ProtectedRoute roles={["admin"]}><AdminFestivals /></ProtectedRoute>} />
          <Route path="/admin/specials" element={<ProtectedRoute roles={["admin"]}><AdminSpecials /></ProtectedRoute>} />
          <Route path="/admin/weekly-menu" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminWeeklyMenu /></ProtectedRoute>} />
          <Route path="/admin/vendors" element={<ProtectedRoute roles={["admin"]}><AdminVendors /></ProtectedRoute>} />
          <Route path="/admin/food-courts" element={<ProtectedRoute roles={["admin"]}><AdminFoodCourts /></ProtectedRoute>} />
          <Route path="/admin/gst-report" element={<ProtectedRoute roles={["admin"]}><AdminGSTReport /></ProtectedRoute>} />
          <Route path="/admin/edkonnect" element={<ProtectedRoute roles={["super_admin"]}><AdminEdkonnect /></ProtectedRoute>} />
          <Route path="/admin/qr-codes" element={<ProtectedRoute roles={["admin"]}><AdminQRCodes /></ProtectedRoute>} />
          <Route path="/admin/configuration" element={<ProtectedRoute roles={["super_admin"]}><AdminConfiguration /></ProtectedRoute>} />
          <Route path="/admin/item-sales" element={<ProtectedRoute roles={["admin"]}><AdminItemSales /></ProtectedRoute>} />
          <Route path="/admin/consumption-log" element={<ProtectedRoute roles={["admin","super_admin","canteen_admin"]}><AdminConsumptionLog /></ProtectedRoute>} />

          <Route path="/pos" element={<ProtectedRoute roles={["operator","admin"]}><POS /></ProtectedRoute>} />
          <Route path="/kds" element={<ProtectedRoute roles={["operator","admin"]}><KDS /></ProtectedRoute>} />
          <Route path="/vendor" element={<ProtectedRoute roles={["vendor"]}><VendorPortal /></ProtectedRoute>} />
          <Route path="/rfid-terminal" element={<ProtectedRoute roles={["operator","admin","super_admin","canteen_admin"]}><RfidTerminal /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute roles={["parent","student","staff","admin","vendor","operator","super_admin"]}><Profile /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
